import { currentMonth, currentYear } from "../functions/dates"

import React from "react"

export const routeClass = key => {
  return window.location.pathname.includes(key) ? "isActive" : ""
}

export const capitalize = s => {
  if (typeof s !== "string") return ""
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const getCurrentMonth = () => currentMonth

export const getCurrentYear = () => currentYear

export const renderEntryServerFields = date => {
  const getDates = date => {
    Date.longMonths = [
      "january",
      "february",
      "march",
      "april",
      "may",
      "june",
      "july",
      "august",
      "september",
      "october",
      "november",
      "december",
    ]
    const dateObj = new Date(date)
    const year = dateObj.getFullYear()
    const month = Date.longMonths[dateObj.getMonth()]
    return { year, month }
  }
  return getDates(date)
}

export const renderEditData = document => {
  let date = document.date ? new Date(document.date) : new Date()
  // key
  const { key } = document
  // text
  let { text } = document
  text = text ? text.replace(/<\/p><p>/gm, "\n\n") : text
  text = text ? text.replace(/<[^>]*>?/gm, " ") : text
  text = text.trim()

  return { document, date, key, text }
}

/**
 * The firebase server/database is in UTC, so any dates we send to it need
 * to be reconciled as the equivalent date/time in the user's local timezone.
 * For example, in GMT+1 (paris) the difference is (-60).  If we send a date like
 *"2019-01-01T00:00:00Z" to Firebase to be saved, it will be saved as that time/date in UTC
 * so actually the day would be 2019-12-11T23:00:00Z.  This function calculates
 * the offset between user's local timezone and UTC and generates an equivalent date
 * object in UTC.
 * @param {Object} dateObject any initialized date object
 */
export const getEqualServerDateTime = (
  dateObject = new Date(),
  isQuickAdd = false
) => {
  let send
  if (isQuickAdd) {
    // send = new Date(
    //   dateObject.getTime() - dateObject.getTimezoneOffset() * 1000 * 60
    // ).toString()
    send = new Date(dateObject).toString()
  } else {
    send = new Date(dateObject).toString()
  }

  console.log(
    "TCL: getEqualServerDateTime -> debug mike",
    `Saved Date: ${send}`
  )

  return send
}

export const renderDisplayDate = dateObject => {
  // console.log("TCL: dateObject", dateObject)

  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  }
  let formatted = dateObject.toLocaleDateString("en-US", options)
  let formattedTime = dateObject.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  const dashed = formatted.split("day, ")
  const formattedDay = `${dashed[0]}day`
  const formattedRest = ` — ${dashed[1]}`
  const formattedNoDay = dashed[1]
  formatted = `${formattedDay}${formattedRest}`
  const markup = (
    <div>
      <strong>{formattedDay}</strong>
      {formattedRest}
    </div>
  )

  const markupTime = (
    <div>
      <div>
        <strong>{formattedDay}</strong>
        {formattedRest}
      </div>
      <span>{formattedTime}</span>
    </div>
  )

  return {
    date: dateObject,
    displayDate: formatted,
    displayNoDay: formattedNoDay,
    markup,
    markupTime,
  }
}

export const renderDisplayDateTime = dateObject => {
  const date = renderDisplayDate(dateObject).displayNoDay
  const time =
    dateObject.getHours() +
    ":" +
    `${
      dateObject.getMinutes() < 10
        ? `0${dateObject.getMinutes()}`
        : dateObject.getMinutes()
    }` +
    ":" +
    `${
      dateObject.getSeconds() < 10
        ? `0${dateObject.getSeconds()}`
        : dateObject.getSeconds()
    }` +
    ` ${dateObject.getHours() >= 12 ? "PM" : "AM"}` +
    ` ${window.Intl.DateTimeFormat().resolvedOptions().timeZone}`
  return `${date} ${time}`
}

export const getRandomQuote = quotes => {
  let quote
  const quotesArray = quotes
  const numQuotes = quotesArray.length
  const rand = Math.floor(Math.random() * Math.floor(numQuotes))
  quote = quotesArray[rand]
  const { text, author: attr } = quote
  return { text, attr }
}

/**
 * Checks if the current environment is within
 * the tested env's array (production | beta).
 * @param {Object} test an array of env's to test
 */
export const isEnv = (test = []) => {
  let result = false
  const envs = []
  const host = window.location.host

  if (host.includes("reflection.app")) envs.push("production")

  if (host.includes("localhost") || host.includes("staging")) envs.push("beta")

  test.forEach(x => {
    if (envs.includes(x)) result = true
  })

  return result
}
